import { useEffect, useState } from 'react';
import { api } from '../../../../services/store/modules/incident-report';
import { IncidentReport } from '../../../../services/store/modules/incident-report/models';

const useIncidentReport = (
  id: string,
): {
  incident: IncidentReport | undefined;
  loading: boolean;
  error: boolean;
} => {
  const [incident, setIncident] = useState<IncidentReport>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    const loadIncidentReport = async () => {
      // This will likely be put into redux
      const { data } = await api
        .getIncidentReport({
          id,
        })
        .catch((d) => {
          setError(true);
          return d;
        })
        .finally(() => {
          setLoading(false);
        });
      setIncident(data);
    };

    loadIncidentReport();
  }, [id]);

  return {
    incident,
    error,
    loading,
  };
};

export default useIncidentReport;
